import { render, staticRenderFns } from "./productRecommend.vue?vue&type=template&id=4b06a442&scoped=true"
import script from "./productRecommend.vue?vue&type=script&lang=ts"
export * from "./productRecommend.vue?vue&type=script&lang=ts"
import style0 from "./productRecommend.vue?vue&type=style&index=0&id=4b06a442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06a442",
  null
  
)

export default component.exports